import * as React from 'react';
import { Segment, Grid, Header, Image, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

interface Props {
  mobile?: boolean
}

export const WhatIsLonchSegment: React.SFC<Props> = (props) =>
  <Segment style={{ padding: '4em 0em' }} vertical>
    <Grid container stackable>
      <Grid.Row>
        <Grid.Column width={8}>
          <Header as='h3' style={{ fontSize: '2em' }}>What is Lonch?</Header>
          <p style={{ fontSize: '1.33em' }}>
            Lonch is a product accelerator platform which combines crowd investment with a social network of doers. It connects visionaries with contributors to pitch and build products and convert sweat equity into royalties.
          </p>
          <p style={{ fontSize: '1.33em' }}>
            Lonch bypasses the traditional challenges of starting and maintaining a business so that entrepreneurs can focus on the successful creation and launching of the product. Lonch provides the infrastructure and tools to allow anyone to contribute their skills to innovate and launch products, with little to no up front costs and reduce the risk of uncertainty while working with other skilled and driven people all around the world.
          </p>
        </Grid.Column>
        <Grid.Column floated="right" textAlign="center" width={6}>
          <Image
            size='large'
            src='/images/what-is-lonch.png'
            style={{ display: "inline-block" }}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column textAlign='center'>
          <Button as={Link} to="/sign-up" size='huge'>Sign Up Now</Button>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Segment>



// WEBPACK FOOTER //
// ./src/home/WhatIsLonchSegment.tsx